import ResizeObserver from "resize-observer-polyfill";
import { add, contains, listen, qs, remove, toggle } from "@fluorescent/dom";

import { section } from "@/neon";
import { emit, on } from "@/neon/events";
import { preventDefault } from "@/utils";

import QuickCart from "@/lib/quick-cart";
import QuickSearch from "@/lib/quick-search";
import Navigation from "@/lib/navigation";
import Menu from "@/lib/drawer-menu";

function setHeaderHeightVar(height) {
  document.documentElement.style.setProperty("--height-header", height + "px");
}

section("header", {
  onLoad() {
    const { enableQuickCart, enableQuickAddToCart } = document.body.dataset;
    const cartIcon = qs("[data-js-cart-icon]", this.container);
    const cartIndicator = qs("[data-js-cart-indicator]", cartIcon);
    const count = qs("[data-js-cart-count]", this.container);
    const menuButton = qs("[data-js-menu-button]", this.container);
    const searchButton = qs("[data-search]", this.container);
    const space = qs("[data-header-space]", document);

    const menu = Menu(qs("[data-drawer-menu]"));
    const quickSearch = QuickSearch(qs("[data-quick-search]", this.container));
    const navigation = Navigation(qs("[data-navigation]", this.container));

    // These all return a function for cleanup
    this.listeners = [
      on("cart:updated", ({ cart }) => {
        remove(cartIndicator, "visible");
        setTimeout(() => add(cartIndicator, "visible"), 500);
        count.innerHTML = cart.item_count;
      }),

      listen(menuButton, "click", preventDefault(menu.open)),
      listen(searchButton, "click", preventDefault(quickSearch.open)),
    ];

    // Components return a destroy function for cleanup
    this.components = [menu, quickSearch, navigation];

    if (enableQuickCart || enableQuickAddToCart) {
      const quickCart = QuickCart(qs("[data-quick-cart]", this.container));
      this.components.push(quickCart);

      if (enableQuickCart) {
        this.listeners.push(
          listen(cartIcon, "click", preventDefault(quickCart.open))
        );
      }
    }

    // Our header is always sticky (with position: sticky) however at some
    // point we want to adjust the styling (eg. box-shadow) so we toggle
    // the is-sticky class when our arbitrary space element (.header__space)
    // goes in and out of the viewport.
    this.io = new IntersectionObserver(([{ isIntersecting: visible }]) => {
      toggle(this.container, "is-sticky", !visible);
    });
    this.io.observe(space);

    // This will watch the height of the header and update the --height-header
    // css variable when necessary. That var gets used for the negative top margin
    // to render the page body under the transparent header
    this.ro = new ResizeObserver(([{ target }]) => {
      if (!contains(target, "is-sticky")) {
        setHeaderHeightVar(target.offsetHeight);
      }
    });
    this.ro.observe(this.container);
  },

  onUnload() {
    this.listeners.forEach(l => l());
    this.components.forEach(c => c.destroy());

    this.io.disconnect();
    this.ro.disconnect();
  },

  onBlockSelect({ target }) {
    if (target.dataset.megaNavLegacy === "") {
      emit("megaNavLegacy:open", null, { id: target.dataset.id });
    } else if (target.dataset.megaNav === "") {
      emit("megaNav:open", null, { id: target.dataset.id });
    }
  },

  onBlockDeselect({ target }) {
    if (target.dataset.megaNavLegacy === "") {
      emit("megaNavLegacy:close");
    } else if (target.dataset.megaNav === "") {
      emit("megaNav:close");
    }
  },
});
